import React from 'react';
import { DiscardScreen } from '@atlassian/generative-ai-modal/screens/Discard';
import { useAnalyticsFlowEventsQueue } from '../../analytics/analytics-flow/analyticsFlowUtils';
import { useIntl } from 'react-intl-next';
import { messages as experienceMessages } from '../messages';
export const getDiscardMessage = ({
  formatMessage,
  experienceState
}) => {
  const discardPrompt = formatMessage(experienceMessages.discardMessagePrompt);
  const discardResponse = formatMessage(experienceMessages.discardMessageResponse);
  if (typeof experienceState === 'object' && 'user input state' in experienceState) {
    return discardPrompt;
  }
  if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) {
    return discardResponse;
  }
  return discardResponse;
};
export function DiscardScreenWithLogic({
  state,
  endExperience,
  send,
  editCount,
  retryPromptCount,
  history,
  channelID
}) {
  const lastHistoryEvent = history.entries[history.positionFromEnd];
  const inputOutputDiffRatio = history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
  useAnalyticsFlowEventsQueue({
    stepName: 'discard',
    attributes: {
      editCount,
      retryPromptCount,
      inputOutputDiffRatio
    }
  });
  const {
    formatMessage
  } = useIntl();
  return /*#__PURE__*/React.createElement(DiscardScreen, {
    text: getDiscardMessage({
      formatMessage,
      experienceState: state
    }),
    onCancel: function () {
      send({
        type: 'disable discard'
      });
    },
    onDiscard: function () {
      endExperience(channelID);
    }
  });
}